import { createApi } from '@reduxjs/toolkit/query/react';

import { HTTP_METHOD, REDUX_CACHE, USERS } from '../constants';
import * as endpoints from '../endpoints';
import { TransformedResponseWithNotification, getBaseQuery } from '../generic';
import { usersApi } from './users/usersApi';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  tagTypes: [],
  baseQuery: getBaseQuery(),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    subscribeToPlanApi: builder.mutation<
      { clientSecret: string | null },
      { planId: string }
    >({
      query({ planId }) {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.PLAN}/${planId}${endpoints.Payments.SUBSCRIPTIONS}`,
          method: HTTP_METHOD.POST,
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(usersApi.util.invalidateTags([USERS.ME, USERS.ME_DETAILED]));
        } catch {
          // Failed mutation — do not invalidate; avoid unhandled rejection from await queryFulfilled
        }
      },
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
      // ...TransformedResponseWithNotification("Subscription")
    }),
    setupIntentApi: builder.mutation<{ clientSecret: string }, void>({
      query() {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.SETUP_INTENT}`,
          method: HTTP_METHOD.POST,
        };
      },
      invalidatesTags: [],
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
    }),
    createDonationIntentApi: builder.mutation<
      { clientSecret: string | null },
      { amountMinor: number }
    >({
      query(body) {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.DONATIONS_INTENTS}`,
          method: HTTP_METHOD.POST,
          body,
        };
      },
    }),
    cancelPlanApi: builder.mutation<void, void>({
      query() {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.SUBSCRIPTIONS}${endpoints.Payments.CURRENT}`,
          method: HTTP_METHOD.DELETE,
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(usersApi.util.invalidateTags([USERS.ME, USERS.ME_DETAILED]));
        } catch {
          // Failed mutation — do not invalidate; avoid unhandled rejection from await queryFulfilled
        }
      },
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
      // ...TransformedResponseWithNotification("Subscription")
    }),
  }),
});

export const {
  useCancelPlanApiMutation: useCancelPlan,
  useCreateDonationIntentApiMutation: useCreateDonationIntent,
  useSetupIntentApiMutation: useSetupIntent,
  useSubscribeToPlanApiMutation: useSubscribeToPlan,
} = paymentApi;
